import {
  createAssessment,
  // uploadAudioFile,
  allocationBattery,
  updateAssessmentStatus,
  printAssessment,
} from './assessment.crud'
import {
  getScoreRatingMethods,
} from './rating.crud'
import {
  saveWord,
  getWords,
  getAudioFile,
} from './words.crud'
import {
  getWordsAndRegions,
} from './region.crud'
import {
  createAffiliation,
  getAffiliations
} from './affiliation.crud'
import {
  getGrades,
  getTestTakersOptions,
  getAllTestTakers,
  getWithLastAssessment,
  getTClasses,
  getTestTaker
} from './testTakers.crud'

const appMiddleware = [
  getTClasses,
  getScoreRatingMethods,
  getTestTakersOptions,
  getAllTestTakers,
  getTestTaker,
  createAssessment,
  printAssessment,
  getGrades,
  allocationBattery,
  updateAssessmentStatus,
  createAffiliation,
  // uploadAudioFile,
  getAffiliations,
  getWordsAndRegions,
  saveWord,
  getWords,
  getAudioFile,
  getWithLastAssessment
]

export default appMiddleware
